import React from "react";
import { Col } from "react-bootstrap";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import BasicProfileErrorMsg from "../../BasicProfileErrorMsg";
export var applicantRelationships = [
    {
        display: "Select Relationship",
        value: "",
        code: "",
    },
    {
        display: "Spouse",
        value: "Spouse",
        code: "1",
    },
    {
        display: "Son",
        value: "Son",
        code: "2",
    },
    {
        display: "Daughter",
        value: "Daughter",
        code: "3",
    },
    {
        display: "Father",
        value: "Father",
        code: "4",
    },
    {
        display: "Mother",
        value: "Mother",
        code: "5",
    },
    {
        display: "Brother",
        value: "Brother",
        code: "6",
    },
    {
        display: "Sister",
        value: "Sister",
        code: "7",
    },
    {
        display: "Grandson",
        value: "Grandson",
        code: "8",
    },
    {
        display: "Granddaughter",
        value: "Granddaughter",
        code: "9",
    },
    {
        display: "Grandfather",
        value: "Grandfather",
        code: "10",
    },
    {
        display: "Grandmother",
        value: "Grandmother",
        code: "11",
    },
    {
        display: "Not Provided",
        value: "Not Provided",
        code: "12",
    },
    {
        display: "Others",
        value: "Others",
        code: "13",
    },
];
var NomineeDetailsData = function (props) {
    var _a, _b;
    var device = DeviceContext();
    return (React.createElement(React.Fragment, null, device && device.isDesktop ? (React.createElement(React.Fragment, null, (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.map(function (alpha) {
        var _a;
        return (React.createElement(React.Fragment, null, (_a = alpha === null || alpha === void 0 ? void 0 : alpha.DematDetails) === null || _a === void 0 ? void 0 : _a.map(function (beta) {
            return (React.createElement(React.Fragment, null, (beta === null || beta === void 0 ? void 0 : beta.Nominee_Details) &&
                (beta === null || beta === void 0 ? void 0 : beta.Nominee_Details.length) > 0 ? (beta === null || beta === void 0 ? void 0 : beta.Nominee_Details.map(function (nomineeItem, index) {
                var _a;
                return (React.createElement("div", { className: "profile-outer-box mt-3", key: index },
                    React.createElement(Col, { lg: 12, className: "grid-3-full px-30 mgt-30 " },
                        React.createElement("span", { className: "text-left" },
                            React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey" }, "Nominee Name"),
                            React.createElement("span", { className: "DMSans_16_500 txt_blackOne1 ps-2" }, nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.FirstName)),
                        React.createElement("span", { className: "text-left" },
                            React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey" }, "Percentage of Share"),
                            React.createElement("span", { className: "DMSans_16_500 txt_blackOne1 ps-2" }, Number(nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.NomineePercentage).toString() + "%")),
                        React.createElement("span", { className: "text-left" },
                            React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey" }, "Nominee DOB"),
                            React.createElement("span", { className: "DMSans_16_500 txt_blackOne1 ps-2" }, nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.BirthDate))),
                    React.createElement(Col, { lg: 12, className: "grid-3-full px-30 mgt-30 pb-4" },
                        React.createElement("span", { className: "text-left" },
                            React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey mr-3" }, "Address Details"),
                            (nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.AddressLine1) &&
                                nomineeItem.AddressLine1 !== "-----" &&
                                "  ".concat(nomineeItem.AddressLine1),
                            (nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.AddressLine2) &&
                                nomineeItem.AddressLine2 !== "-----" &&
                                " , ".concat(nomineeItem.AddressLine2),
                            (nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.AddressLine3) &&
                                nomineeItem.AddressLine3 !== "-----" &&
                                " , ".concat(nomineeItem.AddressLine3),
                            (nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.AddressLine4) &&
                                nomineeItem.AddressLine4 !== "-----" &&
                                " , ".concat(nomineeItem.AddressLine4)),
                        React.createElement("span", { className: "text-left" },
                            React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey" }, "Guardian Details"),
                            React.createElement("span", { className: "d-flex" }, nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.IsGuardianOfNominee)),
                        React.createElement("span", { className: "text-left" },
                            React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey" }, "Relationship"),
                            React.createElement("span", { className: "DMSans_16_500 txt_blackOne1 ps-2 pe-2" }, (_a = applicantRelationships === null || applicantRelationships === void 0 ? void 0 : applicantRelationships.find(function (rel) {
                                if (rel.code ===
                                    String(Number(nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.NomineeRelationShip))) {
                                    return rel;
                                }
                            })) === null || _a === void 0 ? void 0 : _a.display)))));
            })) : (React.createElement("div", { className: "py-2" },
                React.createElement(BasicProfileErrorMsg, { errorName: "Nominee Details" })))));
        })));
    }))) : (React.createElement(React.Fragment, null, (_b = props === null || props === void 0 ? void 0 : props.data) === null || _b === void 0 ? void 0 : _b.map(function (alpha) {
        var _a;
        return (React.createElement(React.Fragment, null, (_a = alpha === null || alpha === void 0 ? void 0 : alpha.DematDetails) === null || _a === void 0 ? void 0 : _a.map(function (beta) {
            var _a;
            return (React.createElement(React.Fragment, null, (_a = beta === null || beta === void 0 ? void 0 : beta.Nominee_Details) === null || _a === void 0 ? void 0 : _a.map(function (nomineeItem) {
                var _a;
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "border-outer-box mt-10" },
                        React.createElement("div", { className: "brd-bottom pt-3 mobile-gc-table pb-3" },
                            React.createElement("div", { className: "main-id-row" },
                                React.createElement("div", { className: "main-id-col" }, "Nominee Name"),
                                React.createElement("div", { className: "main-id-col-data" },
                                    " ", nomineeItem === null || nomineeItem === void 0 ? void 0 :
                                    nomineeItem.FirstName)),
                            React.createElement("div", { className: "main-id-row" },
                                React.createElement("div", { className: "main-id-col" }, "Percentage of Share"),
                                React.createElement("div", { className: "main-id-col-data" }, nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.NomineePercentage)),
                            React.createElement("div", { className: "main-id-row" },
                                React.createElement("div", { className: "main-id-col" }, "Nominee DOB"),
                                React.createElement("div", { className: "main-id-col-data" },
                                    " ", nomineeItem === null || nomineeItem === void 0 ? void 0 :
                                    nomineeItem.BirthDate)),
                            React.createElement("div", { className: "main-id-row" },
                                React.createElement("div", { className: "main-id-col" }, "Relationship"),
                                React.createElement("div", { className: "main-id-col-data" },
                                    " ",
                                    React.createElement("div", { className: "DMSansMedium_12_500  txt_blackOne1 ps-2 pe-2" }, (_a = applicantRelationships === null || applicantRelationships === void 0 ? void 0 : applicantRelationships.find(function (rel) {
                                        if (rel.code ===
                                            String(Number(nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.NomineeRelationShip))) {
                                            return rel;
                                        }
                                    })) === null || _a === void 0 ? void 0 : _a.display))),
                            React.createElement("div", { className: "main-id-row" },
                                React.createElement("div", { className: "main-id-col mr-3" }, "Address Details"),
                                React.createElement("div", { className: "main-id-col-data" },
                                    (nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.AddressLine1) &&
                                        nomineeItem.AddressLine1 !== "-----" &&
                                        "  ".concat(nomineeItem.AddressLine1),
                                    (nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.AddressLine2) &&
                                        nomineeItem.AddressLine2 !== "-----" &&
                                        " , ".concat(nomineeItem.AddressLine2),
                                    (nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.AddressLine3) &&
                                        nomineeItem.AddressLine3 !== "-----" &&
                                        " , ".concat(nomineeItem.AddressLine3),
                                    (nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.AddressLine4) &&
                                        nomineeItem.AddressLine4 !== "-----" &&
                                        " , ".concat(nomineeItem.AddressLine4))),
                            React.createElement("div", { className: "main-id-row" },
                                React.createElement("div", { className: "main-id-col" }, "Guardian Details"),
                                React.createElement("div", { className: "main-id-col" }, nomineeItem === null || nomineeItem === void 0 ? void 0 : nomineeItem.IsGuardianOfNominee),
                                React.createElement("span", { className: "text-left" }))))));
            })));
        })));
    })))));
};
export default NomineeDetailsData;
